<template>
  <div class="dashboard">
    <ProgressHUD
        ref="progress"
        :display="false"
    />

    <layout-main>
      <div>
      <div class="row">
          <div class="col-lg-12 d-head">
              <h4 class="page-header">Dashboard</h4>
              <!-- <a href="#" @click="showPopup()" class="btn-w">GET Discount Code</a> -->
          </div>
      </div>
      <div class="row top-row">
          <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="panel panel-green green-wallet">
                  <div class="panel-heading top-panel-heading">Wallet</div>
                  <div class="panel-content wallet-top">
                    <div class="col-xs-12 col-lg-3 col-md-3">  
                      <img src="static/dist/images/Greeneum Symbol Logo.png">
                      <!-- <span>{{sumTokens}}</span> -->
                      <!-- <div class="block_green" v-if="!profileData.user.walletAddressGREEN && !profileData.user.walletAddressETH">
                        <router-link class="btn-green" to="/contribute">Get your GREEN</router-link>
                      </div> -->
                      <!-- <div v-else> -->
                      <div>
                        <span>{{green}}</span>
                        <p>GREEN(erc20) <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="erc20 Etherum Blockchain (ETH)"></i>
                        </p>
                      </div>
                    </div>        
                    <div class="col-xs-12 col-lg-3 col-md-3">
                      <img src="static/dist/images/Greeneum Symbol Logo.png">                              
                      <span>{{bep20}}</span>
                      <p>GREEN(bep20) <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="bep20 Binance Smart Chain (BSC)"></i></p>
                    </div>  
                    <div class="col-xs-12 col-lg-3 col-md-3" v-show="profileData.user.typeOfProfile=='investor'">
                      <img src="static/dist/images/Greeneum Symbol Logo.png">                              
                      <div>
                        <span>0</span>
                        <p>Total GREEN Bonds</p>
                      </div>                                
                    </div>
                    <div class="col-xs-12 col-lg-3 col-md-3">
                      <img src="static/dist/images/Greeneum-Green-Certificates.png">
                      <span>{{ sumGGC }}</span>
                      <p>Total GREEN Certificates   <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Your Total Green Energy Production (MWh)"></i></p>
                    </div>
                    <div class="col-xs-12 col-lg-3 col-md-3">
                      <img src="static/dist/images/Greeneum-Carbon-Credits.png">
                      <span>{{ sumGCC }}</span>
                      <p>Total Carbon Credits    <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Your Carbon Foot Print Savings"></i></p>
                    </div>
                    <div class="col-xs-12 col-lg-3 col-md-3">
                      <img src="static/dist/images/Greeneum-Green-Certificates.png">
                      <span>{{ (sumGGC*0.1).toFixed() }}</span>
                      <p>Total Staked GREEN Tokens    <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Your Total Staked GREEN. 3% yearly interest"></i></p>
                    </div>                    
                  </div>
              </div>
          </div>

          <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="panel panel-green green-wallet" v-if="profileData.user.typeOfProfile!='investor'">
                  <!-- <div class="panel-heading top-panel-heading">Energy Generation</div> -->
                  <div class="panel-heading top-panel-heading">My Projects</div>
                 <!-- <div class="panel-content p-block" style="text-align:center;" v-if="datacollection.datasets && datacollection.datasets.length > 0"> -->
                  <div class="panel-content p-block" style="text-align:center;padding-bottom:7px;float:left;width:100%;padding-right:30px;" >
                      <router-link class="addProject" :class="{ 'no-data': profileData.projectsExist.length < 0 }"  to="/project/systemsdetail/existing/add">Adding Green Energy Project</router-link>
                      <div class="tab-content">
                        <div class="eg" v-if="profileData.projectsExist.length > 0">
                          <p>
                            <span >Project Name</span>
                            <span class=""> <b>Type</b></span>
                            <span class=""> <b>Nameplate Capacity, Mw</b></span>
                            <span class=""> <b>Estimated Yearly, MWh</b></span>
                            <span class=""> <b>Estimated Monthly, MWh</b></span>
                            <span class=""> <b>Total, MWh</b></span>
                            <span class=""> <b>Saving CO2, tonnes</b></span>                            
                          </p>                          
                          <p class="p-block" v-for="(t, index) in profileData.projectsExist" v-bind:key="index" v-on:click.capture="goToDetailPage(t._id)"> 
                            <span class="" :title="t.name"> {{t.name}} </span>
                            <span class=""> <img class="logo-type" :width="(t.type.toLowerCase().indexOf('hydro')>-1) ? 16 : ''" :src="t.typeLogo" > </span>
                            <span class=""> {{ (t.nameplateCapacity ) ? (t.capacitySize == "MW") ? t.nameplateCapacity : (t.nameplateCapacity/1000).toFixed(2) : 0 }} </span>
                            <span class=""> {{ (t.sumYearMwh) ? t.sumYearMwh.toFixed(2) : 0 }} </span>
                            <span class=""> {{ (t.monthlyMwh) ? t.monthlyMwh.toFixed(2) : 0 }} </span>
                            <span class=""> {{ (t.amountEstimated) ? t.amountEstimated.toFixed() : 0 }} </span>
                            <span class=""> {{ (t.amountSavingCO2) ? t.amountSavingCO2.toFixed() : 0 }} </span>
                          </p>                          
                        </div>
                      </div>                     
                  </div>                  
                  <div class="clear" style="clear: left;"></div>                  
              </div>
              <div class="panel panel-green" v-else>
                  <div class="panel-heading top-panel-heading">Transactions
                  </div>
                 <!--  <div class="panel-content p-block" style="text-align:center;" v-if="datacollection.datasets && datacollection.datasets.length > 0">
                  </div> -->
                  <div class="no-project">
                    <p>No data yet.</p>
                    <br>
                    <p>As soon as our Trade is open, you will see here your tokens, certificates and credits transactions.</p>
                  </div>
              </div>
          </div>
 
          <!-- <div class="col-lg-7 col-md-7 col-xs-12">
              <div class="panel panel-green" v-if="profileData.user.typeOfProfile!='investor'">
                  <div class="panel-heading top-panel-heading">Energy Generation
                  </div>
                   <div class="no-project">
                    <p>No data yet.</p>
                    <br>
                    <p>Start adding projects and reporting production to keep track of all of your production.</p>
                    <router-link class="btn-green" to="/report">Monthly Energy Production</router-link>
                    <router-link class="btn-green addProject red" to="/">Monthly Energy Consumption</router-link>
                    <a class="btn-green" href="https://www.greeneum.net/greeneum-what-we-offer">Get SolarPET</a>
                  </div>
              </div>
              <div class="panel panel-green" v-else>
                  <div class="panel-heading top-panel-heading">Transactions
                  </div>                
                  <div class="no-project">
                    <p>No data yet.</p>
                    <br>
                    <p>As soon as our Trade is open, you will see here your tokens, certificates and credits transactions.</p>
                  </div>
              </div>
          </div> -->

          <!-- <div class="col-lg-8 col-md-8 col-xs-12">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">Transactions</div>

                  <div class="no-project">
                    <p>No data yet.</p>
                    <br>
                    <p>As soon as our Trade is open, you will see here your tokens, certificates and credits transactions.</p>
                  </div>
              </div>
          </div> -->
      </div>

      <!-- <div class="row top-row row-line my-projects" v-if="profileData.user.typeOfProfile!='investor'">
          <div class="col-lg-12 col-md-12 col-xs-12 my-production">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">My Projects</div>

                  <div class="panel-content p-block projects" v-if="profileData == null || profileData.projectsExist == null || profileData.projectsExist.length == 0">
                    <div class="col-lg-6 col-md-6 project">
                      <router-link class="addProjectRect" to="/project/systemsdetail/existing/add">+ Project</router-link>
                    </div>
                     <div class="btn-prj">
                        <router-link class="addProject" to="/project/systemsdetail/existing/add">Adding Green Energy Project</router-link><br>                        
                        <router-link class="addProject" to="/projects?my=true">Get GREEN</router-link>
                      </div>
                  </div>

                  <div class="panel-content p-block projects dashboard-carousel" v-else>

                            <div class="tab-content">
                              <div class="eg myprj">
                                <p >
                                  <span >Name</span>
                                  <span class=""> <b>Image</b></span>
                                  <span class=""> <b>Country, city</b></span>
                                  <span class=""> <b>Public</b></span>
                                  <span class=""> <b>Green Certificates</b></span>
                                  <span class=""> <b>Carbon Credits</b></span>
                                  <span class=""> <b>Staked GREEN</b></span>
                                  <span class=""> <b>Social Impact Project</b></span>
                                  <span class=""> <b>Status</b></span>
                                </p>
                                <p v-for="(project, index) in profileData.projectsExist" v-bind:key="index">
                                  <span class="" :title="project.name"> {{ project.name }} </span>
                                  <span class=""> <img class="" width="30" :src="project.images[0]" /> </span>
                                  <span class="" v-if="!(project.country || project.city)"> No data</span>
                                  <span class="" v-else> {{ project.country }} {{ project.city }} </span>
                                  <span class=""> {{ (project.public) ? "yes" : "no" }} </span>
                                  <span class=""> {{ (project.affiliate) ? project.sumGGC : (project.amountCertificates) ? project.amountCertificates : 0 }} </span>
                                  <span class=""> {{ (project.affiliate) ? project.sumGCC : (project.amountCarbonCredits) ? project.amountCarbonCredits : 0 }} </span>
                                  <span class=""> {{ (project.amountTokens) ? (project.amountTokens).toFixed() : 0 }} </span>
                                  <span class=""> {{ (project.social) ? "yes" : "no" }} </span>
                                  <span v-if="project.draft"><b class="inner label label-danger">Draft</b></span>
                                  <span v-else>
                                    <b v-if="project.confirmed && project.ownerConfirmed" class="inner label label-success">Confirmed</b>
                                    <b v-else-if="project.confirmed && !project.ownerConfirmed" class="inner label label-warning">Not confirmed Owner</b>
                                    <b v-else class="inner label label-danger">Not confirmed</b>
                                  </span>

                                </p>
                              </div>
                            </div>

                      <div class="btn-prj">
                        <router-link class="addProject" to="/project/systemsdetail/existing/add">Adding Green Energy Project</router-link><br>
                        <router-link class="addProject" to="/projects?my=true">Get GREEN</router-link>
                        <-- <a class="addProject" href="https://www.greeneum.net/marketplace">Adding Green Energy Product or Technology</a> ->
                      </div>
                  </div>
              </div>
          </div>
      </div> -->

      <div class="row top-row row-line my-projects" v-if="profileData.user.typeOfProfile=='investor'">
          <div class="col-lg-7 col-md-7 col-xs-12 my-production">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">GREEN FUND</div>

                  <div class="panel-content p-block projects"> 
                    <div class="no-project">
                      <p>Coming soon.</p>
                      <br>
                      <p>GREEN Fund is our crowd investing platform for projects in renewable energy and social impact.</p>
                    </div>
                  </div>
              </div>
          </div>

          <div class="col-lg-5 col-md-5 col-xs-12 my-production">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">Investments</div>

                  <div class="panel-content p-block projects"> 
                    <div class="no-project">
                      <p>Coming soon.</p>
                      <br>
                      <p>GREEN Fund is our crowd investing platform for projects in renewable energy and social impact.</p>
                    </div>
                  </div>
              </div>
          </div>          
      </div>   
      </div>   

      <div class="row modal" role="dialog"> 
        <div class="modal-dialog" role="document">
          <div class="col-lg-12 modal-content">
              <h4 class="page-header">GET Discount</h4>
               <div class="modal-body d-body">
                                   <div class="to-wallet">
                                      <b>Get Discount Code</b>
                                    </div>

                                    <div class="line m-cbx">
                                            <span class="inp-label">Select Value:</span>
                                            <div class="line-margin top">
                                                    <div class="green-chbx" :class="{ active: walletCbx=='5' }" v-on:click="walletCbx='5';"><div></div></div>
                                                    <div class="green-chbx-lable">5%</div>                                       
                                            </div>
                                            <div class="line-margin">
                                                    <div class="green-chbx two" :class="{ active: walletCbx=='10' }" v-on:click="walletCbx='10'; "><div></div></div>
                                                    <div class="green-chbx-lable">10%</div>
                                            </div>
                                            <div class="line-margin">
                                                    <div class="green-chbx three" :class="{ active: walletCbx=='15' }" v-on:click="walletCbx='15';"><div></div></div>
                                                    <div class="green-chbx-lable">15%</div>
                                            </div>
                                            <div class="line-margin">
                                                    <div class="green-chbx three" :class="{ active: walletCbx=='20' }" v-on:click="walletCbx='20'; "><div></div></div>
                                                    <div class="green-chbx-lable">20%</div>
                                            </div> 
                                    </div>


                                    <div class="code" style="display: none;">
                                        <input
                                            type="text"
                                            name="discountCode"                                            
                                            class="form-control"
                                            readonly="true"
                                            v-model="discountCode"
                                            placeholder="discountCode"                                            
                                        >                                        
                                      

                                    <div class="form-group info">
                                          <label class="control-label font-style-italic">Please remember this code.</label>
                                    </div>


                                    <button @click="discountConfirm();" class="go confirm">Confirm</button>
                                    </div>
                                      
                                    <button @click="generateDCode();" class="go ok">Ok</button>
                                    </div>
          </div>
        </div>  
      </div>


    </layout-main>
  </div>                    
</template>

<style>  
  .btn-green {    
      background: #55be68;
      color: #fff;
      padding: 7px 16px;
      border-radius: 100px;
      font-weight: 500;
      box-shadow: 0px 3px 5px #ccc;
      line-height: normal;
      font-size: 15px;
      transition: 0.3s;
      margin: 0 auto;
      display: inline-block;
  }
  .block_green { padding-left: 35px; }
  .eg .label {
      white-space: break-spaces;
      font-size: 7px;
  }
  .p-block {
    cursor: pointer;
  }
  .addProject {
      margin-bottom: 10px;
      padding: 20px;
      background: #55be68;
      color: #fff;
      padding: 7px 16px;
      border-radius: 100px;
      font-weight: 500;
      line-height: normal;
      font-size: 15px;
      float: right;
  }
  .panel-content {
    min-height: 120px;
  }
  .addProject.no-data {
    float: none;
    position: relative;
    top: 30px;
  }  
  .p-block:hover {
    background: #f5f5f5;
  }  
</style>

<script>
import LayoutMain from './../../layouts/LayoutMain.vue';
import ProgressHUD from './../ProgressHUD/index.vue'
import Footer from './../Footers/Footer/index.vue'
import LineChart from './../../data/LineChart.js'
import BarChart from './../../data/BarChart.js'
import PieChart from './../../data/PieChart.js'
import { Api, Toast } from './../../services'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Footer,
    LineChart,
    BarChart,
    PieChart,
  },
  data() {
    return {
      profileData: null,
      sumTokens: 0,
      productUnAnswComments: {},
      totalProductUnAnswComments: 0,
      serviceUnAnswComments: {},
      totalServiceUnAnswComments: 0,
      lat: 51.508530,
      lng: -0.076132,
      validResponse: "",
      city: "London",
      location: "United Kingdom",
      hours: 0,
      mins: 0,
      day: "",
      temp: true,
      tempC: "",
      tempF: "",
      conditionText: "",
      conditionIcon: "https:",
      humidity: "",
      precip: "",
      wind: 0,
      windmph: 0,
      activeId: 0,
      datacollection: {},
      barcollection: {},
      piecollection: {},
      heightChart: 0,
      sumGreenCertificates: 0,
      sumBonusCarbon: 0,
      itemsCarousel: 3.25,
      green: 0,
      sumGGC: 0,
      sumGCC: 0,
      bep20: 0,
      yearMwh: {"solar": 1500, "wind": 2400},
      // sumYear: getSumYear(nameplateCapacity, size),
      discountCode: '',
      walletCbx: "5",
      stakedToken: 0,
    }
  },
  methods: {
    // backToGREEN() {
    //   this.$router.go(-1);
    // },

    getSumYear(nameplateCapacity, size){
      return 1500;
    },
    goToDetailPage(id) {
      // $('#exampleModalCenter').modal('close');
      this.$router.push("/project/systemsdetail/existing/" + id)
    },
    openReport(project) {
      this.$refs.sendReport.openReport(project)
    },
    goToDuplicatePage: function(project) {
      this.$router.push("/project/systemsdetail/existing/duplicate/" + project._id)
    },
    showPopup() {
      $('.modal').modal('show');
      $('.code').css('display', 'none');
      $('.go.ok').css('display', 'block');
      this.discountCode = ""
    },
    generateDCode() {      
      this.discountCode = URL.createObjectURL(new Blob([])).toUpperCase()
        .slice(-6)
        .replace(/-/g, '')

       $('.code').css('display', 'block'); 
       $('.go.ok').css('display', 'none');
    },

    async discountConfirm() {
      try {          
        $('.modal').modal('hide')
        $('.modal-backdrop.in').remove() 

        var ownerAmountGGC = (this.profileData.user.ownerAmountCertificates) ? this.profileData.user.ownerAmountCertificates : 0, sum = (this.profileData.user.stakedToken) ? this.profileData.user.stakedToken : (this.profileData.sumGGC + ownerAmountGGC)*0.1
        // console.log(sum)

        this.stakedToken = (sum - this.walletCbx*sum/100).toFixed(2)
        // console.log(this.stakedToken)

        var formData = new FormData()
        formData.append('discountPercent', this.walletCbx)
        formData.append('discountCode', this.discountCode)
        formData.append('stakedToken', this.stakedToken)

        
        // console.log(this.walletCbx, this.discountCode, this.stakedToken)

        var res = await Api.saveStakedToken(formData)

        Toast.success({
                 toast: this.$toast,
                title: 'Success!',
                message: 'Discount Successfully Saved',
              })
      } catch (error) {
          console.error(error)
          this.validationMessage = error.message;

          Toast.error({
            toast: this.$toast,
            title: 'Error',
            message: error.message,
          })
      }   
    },
    async saveWallet() {
      try {          
          var formData = new FormData()
          formData.append('walletAddressGREEN', this.profileData.user.walletAddressGREEN)
          formData.append('contractAddressGREEN', this.profileData.user.contractAddressGREEN)
          var response = await Api.saveWalletGREEN(formData)
          if (response.data) {
            $('.modal').modal('hide')
            $('.modal-backdrop.in').remove()
            Toast.success({
               toast: this.$toast,
              title: 'Success!',
              message: 'Payment Methods Successfully Saved',
            })
          }
      } catch (error) {
          console.error(error)
          this.validationMessage = error.message;
          isGreen=true;

          Toast.error({
            toast: this.$toast,
            title: 'Error',
            message: error.message,
          })
        } finally {
          this.$refs.progress.hide()
        }      
    },
    fetchData() {
      let self = this;
      // prompt for location zipCode / city name / latitude / ip address
      // console.log(`longitude 22 : ${ this.lng } | latitude 22 : ${ this.lat }`);

                let location = (this.lat==0 && this.lng==0) ? this.city : this.lat + "," + this.lng;

                /*if (location === null) {
                    console.log("Cancelled request...try again!");
                    return;
                } else {
                  //36d24e2c59324195b3d134523192201 - my key

                    axios.get("https://api.apixu.com/v1/current.json?key=dbe71ad46a95447ea1a151913170108&q=" + location)
                        .then(function (response) {
                            if (response.status != 200) {
                                self.validResponse = false;
                            } else {
                                self.validResponse = true;

                                // obtain city name, country, temperature, cloud icon,
                                //  cloud info, humidity, wind, precipitation from api
                                self.city = response.data.location.name;
                                self.tempC = Math.floor(response.data.current.temp_c);
                                self.tempF = Math.floor(response.data.current.temp_f);
                                self.conditionText = response.data.current.condition.text;
                                self.conditionIcon = response.data.current.condition.icon;
                                self.humidity = response.data.current.humidity;
                                self.location = response.data.location.country;
                                self.wind = Math.floor(response.data.current.wind_kph);
                                self.windmph = Math.floor(response.data.current.wind_mph);
                                self.precip = response.data.current.precip_mm;

                                // get hours from api
                                let date = new Date(response.data.location.localtime);
                                self.hours = date.getHours();
                                console.log("self----------")
                                console.log(self)
                                // format time minutes
                                if (date.getMinutes() < 10) {
                                    self.mins = "0" + date.getMinutes();
                                } else {
                                    self.mins = date.getMinutes();
                                }

                                // format day of week
                                let days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

                                for (let i = 0; i < days.length; i++) {
                                    if (date.getDay() === i) {
                                        self.day = days[i];
                                    }
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(`Bad Request: ${error}`);
                        });
                }*/
    },
    // Function for create data collection
    createDataCollection(labels, datasets) {
      return {
        labels: labels,
        datasets: datasets
      }
    },


refreshDataForPieChart() {
  // console.log("ipvDataByDay ********************* 1 " , this.barcollection)
      if (this.profileData.projectsExist == undefined || this.profileData.projectsExist == null) return

      // set data for charts
      this.piecollection.labels = []
      this.piecollection.actualData = []    

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 29

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }
      // Get time period for filter
      // for (var indexForIpvData in this.profileData.projectsExist.ipv) {
      var sumNC = 0;
      for (var i=0; i<this.profileData.projectsExist.length; i++) 
        sumNC = sumNC + parseInt(this.profileData.projectsExist[i].nameplateCapacity);
      
      for (var indexForIpvData=1; indexForIpvData<=1; indexForIpvData++) {        
        var ipvDataByDay
        ipvDataByDay = sumNC*12
        if (!ipvDataByDay) {
          console.error('Data for PIE is null')
          continue
        }
        // var ivpDate = this.parseDate(ipvDataByDay.date)

        // if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
        // console.log("**************** PIE ipvDataByDay *********************")
          
        // this.barcollection.labels.push(ipvDataByDay.date)
        this.piecollection.actualData.push(ipvDataByDay)
        // console.log(this.piecollection.actualData)
        // this.barcollection.predictedData.push(ipvDataByDay.predict)
        // }
      }

      this.piecollection = this.createDataPieCollection(
        this.piecollection.labels,
        this.piecollection.actualData,
        // this.barcollection.predictedData
      )
    },


    createDataPieCollection(labels, actualData, predictedData) {
      return {
        labels: ['Solar'],
        datasets: [
          {
            label: 'Solar',
            backgroundColor: '#f7b07b',
            borderColor: '#eb6a0a',
            borderWidth: 1,
            data: [152],
          },
        ],
      }
    },

  

refreshDataForBarChart() {
  //console.log("ipvDataByDay *********************11111" , this.barcollection)
      if (this.profileData.projectsExist == undefined || this.profileData.projectsExist == null) return

      // set data for charts
      this.barcollection.labels = []
      this.barcollection.actualData = []
      this.barcollection.predictedData = []

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 29

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }
      // console.log("ipvDataByDay ********************* 2")

      // Get time period for filter
      // for (var indexForIpvData in this.profileData.projectsExist.ipv) {
      var sumNC = 0;
      for (var i=0; i<this.profileData.projectsExist.length; i++) { 
        // console.log('SUM NC ++++++++++')
        // console.log(this.profileData.projectsExist[i].nameplateCapacity, sumNC)
        sumNC = sumNC + parseInt(this.profileData.projectsExist[i].nameplateCapacity);
      }  
      
      for (var indexForIpvData=1; indexForIpvData<=12; indexForIpvData++) {        
        var ipvDataByDay=[]
        ipvDataByDay[indexForIpvData] = sumNC
        if (!ipvDataByDay) {
          console.error('Data for Bar is null')
          continue
        }
        // var ivpDate = this.parseDate(ipvDataByDay.date)

        // if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
          // console.log("**************** ipvDataByDay *********************")
          // this.barcollection.labels.push(ipvDataByDay.date)
          this.barcollection.actualData.push(ipvDataByDay[indexForIpvData])
          // console.log(this.barcollection.actualData)
          // this.barcollection.predictedData.push(ipvDataByDay.predict)
        // }
      }

      this.barcollection = this.createDataBarCollection(
        this.barcollection.labels,
        this.barcollection.actualData,
        // this.barcollection.predictedData
      )
    },

    // Function for create data collection
    createDataBarCollection(labels, actualData, predictedData) {
      return {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Solar',
            backgroundColor: '#f7b07b',
            borderColor: '#eb6a0a',
            borderWidth: 1,
            data: actualData,
          },
          // {
          //   label: 'Predicted',
          //   backgroundColor: 'rgba(237, 125, 49, 0.2)',
          //   borderColor: 'rgba(237, 125, 49,1)',
          //   borderWidth: 1,
          //   data: predictedData,
          // },
        ],
      }
    },



    refreshDataForChart() {
      if (this.profileData.projectsExist || this.profileData.projectsExist[0] == undefined || this.profileData.projectsExist[0] == null) return
      this.heightChart = (window.innerHeight >= 850) ?  200 : 180;

      // set data for charts
      this.datacollection.labels = []
      this.datacollection.datasets = []
      var bg = ["rgba(91, 155, 213, 1)", "rgba(237, 125, 49, 0.2)","rgba(65, 105, 225, 0.5)", "rgba(0, 250, 154, 1)",
                "rgba(238, 130, 238, 1)", "rgba(0, 128, 128, 0.3)","rgba(147, 112, 216, 1)", "rgba(216, 112, 147, 1)",
                "rgba(104, 142, 35, 1)", "rgba(255, 165, 0, 1)","rgba(112, 128, 144, 0.3)", "rgba(91, 155, 213, 0.2)", "rgba(237, 125, 49, 0.2)","rgba(65, 105, 225, 0.5)", "rgba(0, 250, 154, 1)",
                "rgba(238, 130, 238, 1)", "rgba(0, 128, 128, 0.3)","rgba(147, 112, 216, 1)", "rgba(216, 112, 147, 1)",
                "rgba(104, 142, 35, 1)", "rgba(255, 165, 0, 1)","rgba(112, 128, 144, 0.3)", "rgba(0, 250, 154, 0.1)"]

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 29

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }

      // Get time period for filter
      for(var i=0; i < this.profileData.projectsExist.length; i++) {
        var actualData = [], ipvDateArr = []
        for (var indexForIpvData in this.profileData.projectsExist[i].ipv) {
          var ipvDataByDay = this.profileData.projectsExist[i].ipv[indexForIpvData]
          if (!ipvDataByDay) {
            console.log('IPV Data is null' + this.profileData.projectsExist[i]._id)
            continue
          }

          var ivpDate = this.parseDate(ipvDataByDay.date)

          if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
            actualData.push(ipvDataByDay.actual)
            //ipvDateArr.push(ipvDataByDay.date)
            this.datacollection.labels.push(ipvDataByDay.date)
          }
        }
        // console.log("actualData*****************************" + bg[i])
        // console.log(actualData)
        // console.log(this.profileData.projectsExist[i].name)
        // this.datacollection.labels.push(ipvDateArr)
        this.datacollection.datasets.push({
            label: this.profileData.projectsExist[i].name,
            data: actualData,
            backgroundColor: bg[i],
            borderColor: bg[i],
            borderWidth: 1,
            fill: false
        })

      }


      this.datacollection = this.createDataCollection(
        this.datacollection.labels,
        this.datacollection.datasets
      )
    },
    parseDate(input) {
      var parts = input.split('/')
      return new Date(parts[0], parts[1] - 1, parts[2])
    },
    refreshSize(event) {
      var ctx = document.getElementById("line-chart");
      // console.log(ctx)
      // ctx.canvas.width = 200;
      if (ctx != null && ctx != "null") ctx.height = 200; 
      this.refreshDataForChart()
    },
  },
  getD() {
    return 8;
  },
  async created() {
    $('.p-block').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    })
    try {
      var _s = this

      var response = await Api.myProfile()
      setTimeout(_s.fetchData(), 55000);
      if (response.data) {
        this.profileData = response.data.results
        // console.log("profileData>>>>>>>>>>>>>>>>>")
        // console.log(this.profileData)

        var sumTokens = 0, 
            sumGreenCertificates = 0, 
            sumBonusCarbon =0, 
            pExist = this.profileData.projectsExist, 
            type="", 
            nameplateCapacity = 0,
            logos = {0:"solar", 1:"wind", 2:"gas", 3:"hydro"},
            typeForLogo = "";

        for (var i=0; i<pExist.length; i++){
          sumGreenCertificates = sumGreenCertificates + pExist[i].greenCertificates
          sumBonusCarbon = sumBonusCarbon + pExist[i].bonusCarbon        
          
          type = ((pExist[i].type.toLowerCase()).indexOf("wind")>-1) ? "wind" : "solar"
          nameplateCapacity = (this.profileData.projectsExist[i].capacitySize == "MW") ? this.profileData.projectsExist[i].nameplateCapacity : this.profileData.projectsExist[i].nameplateCapacity/1000
          this.profileData.projectsExist[i].sumYearMwh = this.yearMwh[type]*nameplateCapacity
          this.profileData.projectsExist[i].monthlyMwh = this.profileData.projectsExist[i].sumYearMwh/12
          for (var key in logos){           
            typeForLogo = pExist[i].type.toLowerCase()           
            if (typeForLogo.indexOf(logos[key])>-1) this.profileData.projectsExist[i].typeLogo = '/static/dist/images/' + logos[key] + '-black.svg';
          }
       
          for (var j=0; j<pExist[i].sentTokens.length; j++)
            sumTokens = sumTokens + pExist[i].sentTokens[j].amount
        }
        this.sumTokens = sumTokens
        this.sumGreenCertificates = sumGreenCertificates
        this.sumBonusCarbon = sumBonusCarbon


        if (this.profileData.balanceETH)
          this.green = this.profileData.balanceETH[1].toFixed(2) 
        if(this.profileData.balanceGREENBEP20)
          this.bep20 = this.profileData.balanceGREENBEP20.toFixed(4)          

        var ownerAmountGGC = (this.profileData.user.ownerAmountCertificates) ? this.profileData.user.ownerAmountCertificates : 0, sumGGC=this.profileData.sumGGC, sum1 = 0
      
        sum1 = (sumGGC) ? sumGGC.toFixed(2) : 0
        this.sumGGC = parseFloat(sum1) + ownerAmountGGC
        var ownerAmountGCC = (this.profileData.user.ownerAmountCarbonCredits) ? this.profileData.user.ownerAmountCarbonCredits : 0, sum2 = (this.profileData.sumGCC) ? (this.profileData.sumGCC).toFixed(2) : 0
        this.sumGCC = parseFloat(sum2) + ownerAmountGCC
        
        this.$localStorage.get('userName')

        this.profileData.comments.forEach(item => {
          if (typeof item.product[0] !== 'undefined' && item.product[0]["user"][0] === this.profileData.user._id) {
            if (item.product[0]['type'] === 'Service' ) {
              this.serviceUnAnswComments[item.product[0]['_id']] = (typeof this.serviceUnAnswComments[item.product[0]['_id']] === 'undefined') ? 1 : parseInt(this.serviceUnAnswComments[item.product[0]['_id']]) + 1
              this.totalServiceUnAnswComments++
            } else if (item.product[0]['type'] === 'Product' ) {
              this.productUnAnswComments[item.product[0]['_id']] = (typeof this.productUnAnswComments[item.product[0]['_id']] === 'undefined') ? 1 : parseInt(this.productUnAnswComments[item.product[0]['_id']]) + 1
              this.totalProductUnAnswComments++
            }
          }
        })

        
        if(pExist.length > 0){
          this.lat = pExist[0].latitude;
          this.lng = pExist[0].longitude;
          // this.activeId = pExist[0]._id;
          this.activeId = 0;
          //this.city = this.profileData.user.citiesForWeather[0]
          this.fetchData();
        }
        // this.refreshDataForChart()
        // this.refreshDataForBarChart()
        // this.refreshDataForPieChart()

        await new Promise(resolve => this.$nextTick(resolve));

        
        if($(window).width()<=500)
          this.itemsCarousel = 1.25
        else if($(window).width()<=991)
          this.itemsCarousel = 2.25

         var loopCarousel = (this.profileData.projectsExist.length > 3) ? true : false
        $('.owl-carousel').owlCarousel({
          stagePadding: 50,
          loop: true,
          margin: 20,
          navText: [
            '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="fa fa-angle-right" aria-hidden="true"></i>'
          ],
          navContainer: '.custom-nav',
          loop: loopCarousel,
          nav: false,
          dots: false,
          responsive: {
            0:{
                items: 1.25
            },
            500:{
                items: 2.25
            },
            1000:{
                items: 3.25
            }
          }
          //items: this.itemsCarousel
        });

        if (this.profileData.user.walletAddressGREEN=='' && this.profileData.user.created > 1586908800000 && this.profileData.user.social_auth!='') {
          $('.modal').modal({
            backdrop: 'static',
            keyboard: false
          })
          $('.modal').modal('show')
        }  
      } else {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }

    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
   mounted() {
    window.addEventListener('resize', this.refreshSize)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Dashboard.vue